import { render, staticRenderFns } from "./customer_balance.vue?vue&type=template&id=a6cd653a&"
import script from "./customer_balance.vue?vue&type=script&lang=js&"
export * from "./customer_balance.vue?vue&type=script&lang=js&"
import style0 from "./customer_balance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports